import styled from 'styled-components';

/** The count sits on the action that opens it, so a question carries one clickable row rather than
 * a second icon-and-number strip repeating the same information. */
export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: ${({ theme }) => theme.palette.grey[200]};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 1.3rem;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }
`;
